<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:29:22
 * @LastEditTime: 2019-08-18 22:05:57
 * @LastEditors: Please set LastEditors
 -->

<template>
    <div class="content" v-loading="loading">
        <div class="pageTitle">追踪查询</div>
        <el-form ref="form" :model="form" label-width="100px" :inline="true" style="margin: 20px;">
            <el-form-item label="">
                <el-input v-model="form.logistics_code" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSearch()">搜索</el-button>
            </el-form-item>
        </el-form>
        <div v-if="isTrue">
            <div class="blocknote">
            <span>
                商品信息
            </span>
            </div>
            <!-- <div class="page-table" v-if="baseData">
              
            </div> -->
            <div class="page-table" >
             <div>
                 <span>商品编号</span>
                 <span>{{traceData.product.product_sn}}</span>
             </div>
             <div>
                   <span>商品名称</span>
                 <span>{{traceData.product.product_name}}</span>
             </div>
            </div>
            <div class="blocknote" v-if='traceData.type==2'>
            <span>
                所属经销商
            </span>
            </div>
            <div class="page-table" style="margin: 10px" v-if='traceData.type==2'>
                 <div>
                 <span>经销商编号</span>
                 <span>{{traceData.dealer_or_shop.dealer_sn}}</span>
             </div>
             <div>
                   <span>经销商名称</span>
                 <span>{{traceData.dealer_or_shop.dealer_name}}</span>
             </div>
              <div>
                   <span>销售区域</span>
                 <span> <i v-for="(v,k) in traceData.dealer_or_shop.region" :key='k'>{{v}}</i> </span>
             </div> <div>
                   <span>出货时间</span>
                 <span>{{traceData.dealer_or_shop.created_at}}</span>
             </div>
            </div>
                <div class="blocknote" v-if='traceData.type==3'>
            <span>
               收货门店
            </span>
            </div>
            <div class="page-table" style="margin: 10px" v-if='traceData.type==3'>
                 <div>
                 <span>门店编号</span>
                 <span>{{traceData.dealer_or_shop.shop_sn}}</span>
             </div>
             <div>
                   <span>门店名称</span>
                 <span>{{traceData.dealer_or_shop.shop_name}}</span>
             </div>
              <div>
                   <span>门店类型</span>
                 <span>{{traceData.dealer_or_shop.type_name}}</span>
             </div>
              <div>
                   <span>出货时间</span>
                 <span>{{traceData.dealer_or_shop.created_at}}</span>
             </div>
            </div>
        </div>
        </div>
    
</template>

<script>
    export default {
        name: "trace-manage",
        data() {
            return {
                form:{
                    logistics_code:''
                },
                isShow:false,
               traceData:{},
                big_code_name:'',
                middle_code_name:'',
                small_code_name:'',
                isTrue:false,
                loading:false
            }
        },
        methods: {
            getConfigInfo(){
                this.$get('logistics', '/configs', {
                    lang: ''
                }).then(res => {
                    this.big_code_name = res.data.big_code_name;
                    this.middle_code_name = res.data.middle_code_name;
                    this.small_code_name = res.data.small_code_name;
                }).catch(function (error) {
                  
                });
            },

            onSearch(){
                this.loading = true;
                this.$get('logistics','/logistics.search', {
                    lang:'',
                    logistics_code:this.form.logistics_code
                }).then(res => {
                    this.loading = false;
                    this.isTrue = true;
            
                    this.isShow = true;
                    this.traceData=res.data
                
                }).catch(error => {
                    this.loading = false;
                   if(error.error_no=='98501'){
                       this.$message({
                        type: 'error',
                        message: "该物流码不存在"
                    });
                   }else if(error.error_no=='98502'){
                                this.$message({
                        type: 'error',
                        message: "物流码类型未知"
                    });
                   }else{
                            this.$message({
                        type: 'error',
                        message: error.message
                    });
                   }
                    
                
                });
            }

        },
        created() {
            // this.getConfigInfo();
        },
    }
</script>

<style lang="scss" scoped>
    .content{
        .blocknote{
            height: 60px;
            line-height: 60px;
            margin: 20px;
            background-color: lightgrey;
            padding-left: 20px;
            span{
                font-size: 18px;
            }
        }
        .page-table{
            padding: 10px 20px;
            >div{
                width: 80%;
                // margin: 0 auto;
                border: 1px solid #ccc;
                 border-top: none;
                span{
                    width: 49%;
                    display: inline-block;
                    border-right: 1px solid #ccc;
                    padding: 10px 0;
                    text-align: center;
                }
                span:last-child{
                    border-right: none;
                }
            }
            >div:first-child{
               border-top: 1px solid #ccc;
            }
        }
     
    }
    .content{
        height: 100%;
    }

</style>